import {
    GET_ComCh,
    ADD_ComCh,
    TOGGLE_ComCh,
    RESET_ComCh,
    UPDATE_ComCh
  } from "../actionTypes";

const communicationChannelReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ComCh:
      return action.payload;

    case ADD_ComCh:
      return action.payload;

    case UPDATE_ComCh:
      return state.map(item =>
        item.id === action.payload.id ? action.payload : item
      );

    case TOGGLE_ComCh:
      return {
        ...state,
        users: state.users.map(item =>
          item.userId === action.payload.userId ? action.payload : item
        )
      };

    case RESET_ComCh:
      return null;

    default:
      return state;
  }
};

export default communicationChannelReducer;
